<template>
  <div>
    <v-layout row wrap pt-2>
      <v-flex md4 xs12 pb-2 v-for="(user, i) in list" :key="i">
        <v-card :width="widthCard" height="146px" hover>
          <v-layout align-center fill-height justify-center>
            <v-flex xs4 pl-2>
              <v-img
                :src="user.image"
                :style="`height: 110px; width: 110px; object-fit: cover; border-radius: 50%; border: 3.2px solid `+ user.color + ';'"
              ></v-img>
            </v-flex>
            <v-flex xs8 pl-3 pt-3>
              <v-flex pl-2 font-weight-bold text-14-security>{{user.full_name.toUpperCase()}}</v-flex>
              <v-flex pl-2 text-14-security>{{ user.company }}</v-flex>
              <v-flex pl-2 text-14-security>{{ user.date_entry }}</v-flex>
              <v-flex mt-2>
                <v-btn small round :color="user.color" :href="`mailto:${user.email}`">
                  <h3 class="white--text caption-security font-weight-regular">Enviar saludo</h3>
                </v-btn>
              </v-flex>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <v-flex xs12>
      <infinite-loading @infinite="infiniteHandler">
        <div slot="spinner">Cargando...</div>
        <div slot="no-more" style="visibility: hidden">No hay más resultados</div>
        <v-layout slot="no-results">
          <v-flex sm12>
            <v-card height="400px">
              <v-layout align-center justify-center row wrap fill-height>
                  <v-flex sm12 class="text-29-security text-md-center font-weight-bold" style="color: #525252">No hay bienvenidos este mes</v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </infinite-loading>
    </v-flex>
  </div>
</template>

<script>
import WelcomeItem from "./WelcomeItem";
import axios from "axios";
import { mapMutations, mapState } from "vuex";
import config from "@/config";
export default {
  components: {
    WelcomeItem
  },
  props: {
    date: {
      type: String,
      required: true
    },
    monthNumber: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      page: 1,
      list: [],
    };
  },
  computed: {
    widthCard() {
      if (window.innerWidth > 425) {
        return "380";
      } else {
        return "";
      }
    }
  },
  methods: {
    ...mapMutations("welcomes", ["setWelcomeUser", "setWelcomeUsers"]),
    infiniteHandler($state) {
      let api = `${process.env.VUE_APP_API_URL}/welcome`;
      axios.get(api, { params: { page: this.page, date: this.monthNumber + 1 } }).then(({ data }) => {
        if (data.hits.length) {
          this.page += 1;
          const newUsers = data.hits.filter(newUser => {
            return !this.list.some(existingUser => existingUser.id === newUser.id);
          });
          this.list.push(...newUsers);
          this.setWelcomeUsers(this.list);
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    }
  }
};
</script>

<style>
</style>